import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "key-row" }
const _hoisted_2 = { class: "key-color-box" }
const _hoisted_3 = { class: "key-description" }
const _hoisted_4 = { style: {"margin-left":"10px"} }




export default /*@__PURE__*/_defineComponent({
  __name: 'keyRow',
  props: {
    color: {},
    territory: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "key-color",
        style: _normalizeStyle({ backgroundColor: _ctx.color })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, "- " + _toDisplayString(_ctx.territory), 1)
    ])
  ]))
}
}

})